var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"value-field--inline"},[_c('span',{staticClass:"light-mono",class:{ editable: _vm.editable }},[_vm._v(_vm._s(_vm.displayValue))])])
}
var staticRenderFns = []

export { render, staticRenderFns }